import { gql } from '@apollo/client';
import { rewardFragment } from '../fragments/reward';

export const purchaseRewardMutation = gql`
    ${rewardFragment}
    
    mutation PurchaseReward($rewardId: String!)
    {
        purchaseReward(id: $rewardId) 
        {
            reward {
              ...RewardFields
            }
            user {
              id
              collectedCurrency
            }
            eventLog {
              id
              createdAt
              rewardPurchased {
                rewardId
                currencyPaid
              }
            }
        }
    }
`;